import { get } from '../../../../../infra/rest';
import requestConfig from '../../../../../shared/config/request';
import { GetOrgOwnersResponse, OrgOwnersPaginationParams } from './typings';

export const ORG_OWNERS_PAGE_SIZE = 20;

export const getOrgOwners = async (params?: OrgOwnersPaginationParams) => {
  const search = new URLSearchParams({ pageSize: String(ORG_OWNERS_PAGE_SIZE) });
  if (params?.sortAfter) {
    search.set('sortAfter', params.sortAfter);
  }
  if (params?.sortAfterDate) {
    search.set('sortAfterDate', params.sortAfterDate);
  }
  return get<GetOrgOwnersResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/organization/owners?${search.toString()}`,
    undefined,
    true,
    false,
    true
  );
};
